import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const PersonalInfoSkeleton = () => (
  <div className={cx(style.personalInfoFields, style.personalInfoFieldsSkeleton)}>
    {[...Array(9)].map((_) => (
      <SkeletonBlock key={uuidv4()} className={style.skeletonField} />
    ))}
  </div>
);

export default PersonalInfoSkeleton;
